//Open external links in a new window
document.addEventListener("DOMContentLoaded", function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }
});

console.log("Gordon's script loaded!")